var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsWashroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.008.036h16.985v42.213H.008z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.017.025h52.305v9.188H.017z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 .058h66.468v42.273H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-986-202H164v754H-986z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.407 22.378)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.162 17.57c0-.721.644-1.322 1.416-1.322.772 0 1.415.6 1.415 1.321v23.359c0 .78-.643 1.32-1.415 1.32H1.424c-.772 0-1.416-.54-1.416-1.32V1.357C.008.636.652.036 1.424.036h14.154c.772 0 1.415.6 1.415 1.32V4.36c0 .72-.643 1.321-1.415 1.321s-1.416-.6-1.416-1.321V2.678H2.84v36.929h11.323V17.569z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.553 55.414)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.52 4.169c-.708.66-1.287 1.5-1.544 2.401h46.322a5.302 5.302 0 0 0-1.48-2.401c-1.029-.961-2.444-1.502-3.988-1.502H8.509c-1.608 0-3.024.54-3.989 1.502zM.017 7.892c0-2.162.965-4.144 2.444-5.585C4.005.866 6.13.025 8.51.025h35.32c2.317 0 4.44.841 5.984 2.282 1.544 1.441 2.509 3.423 2.509 5.585 0 .78-.643 1.32-1.415 1.32H1.432c-.772 0-1.415-.54-1.415-1.32z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.407 61.926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M63.637 2.7H3.675L16.8 27.2c.193.36.193.84 0 1.2l-6.048 11.29h34.42c-6.112-12.55-.643-15.493 6.112-19.276C56.69 17.472 63.122 13.869 63.637 2.7zM1.424.058h63.628c.772 0 1.416.6 1.416 1.321 0 13.75-7.463 17.894-13.704 21.317-5.919 3.242-10.551 5.764-4.118 17.714.322.66.065 1.44-.643 1.801-.193.06-.386.12-.643.12H8.5c-.771 0-1.415-.6-1.415-1.32 0-.241.065-.481.193-.721L13.97 27.8.137 1.98C-.185 1.318.073.537.78.237c.193-.12.45-.12.644-.12v-.06z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.189 31.96a2.33 2.33 0 0 0-1.544-.6c-.58 0-1.094.24-1.48.6-.386.361-.643.841-.643 1.382 0 .54.257 1.02.643 1.381.386.36.9.6 1.48.6a2.33 2.33 0 0 0 1.544-.6c.386-.36.579-.84.579-1.381 0-.54-.193-1.02-.58-1.381m-1.543-3.243c1.35 0 2.637.54 3.538 1.381.9.841 1.416 1.982 1.416 3.243 0 1.26-.515 2.462-1.416 3.242a5.254 5.254 0 0 1-3.538 1.382 5.092 5.092 0 0 1-3.474-1.382 4.347 4.347 0 0 1-1.48-3.242c0-1.261.579-2.402 1.48-3.243a5.092 5.092 0 0 1 3.474-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.183 34.663c-.772 0-1.415-.6-1.415-1.321 0-.72.643-1.321 1.415-1.321h7.656c.772 0 1.416.6 1.416 1.32 0 .721-.644 1.322-1.416 1.322h-7.656zM44.985 91.047c-.772 0-1.416-.6-1.416-1.32 0-.721.644-1.322 1.416-1.322h14.154c.772 0 1.35.6 1.35 1.321 0 .72-.578 1.321-1.35 1.321H44.985z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWashroom);
export default __webpack_public_path__ + "static/media/icons-washroom.b38ade11b60e462ad01aa5e8d4b07eba.svg";
export { ForwardRef as ReactComponent };